import Washing_icon_30_Light from "../assets/images/Washing_icon_30_Light.png";
import Washing_icon_30_Dark from "../assets/images/Washing_icon_30_Dark.png";
import Washing_icon_30_White from "../assets/images/Washing_icon_30_White.png";
import Washing_icon_hand_Light from "../assets/images/Washing_icon_hand_Light.png";
import Washing_icon_hand_Dark from "../assets/images/Washing_icon_hand_Dark.png";
import Washing_icon_hand_White from "../assets/images/Washing_icon_hand_White.png";

const DEFAULT_WASHINGS = [
  {
    value: "30 Dark Colours",
    label: "30° Dark Colours",
    icon: Washing_icon_30_Dark,
    default: true,
  },
  {
    value: "30 Light Colours",
    label: "30° Light Colours",
    icon: Washing_icon_30_Light,
  },
  { value: "30 White", label: "30° White", icon: Washing_icon_30_White },
  {
    value: "Handwash Dark",
    label: "Handwash Dark",
    icon: Washing_icon_hand_Dark,
  },
  {
    value: "Handwash Light",
    label: "Handwash Light",
    icon: Washing_icon_hand_Light,
  },
  {
    value: "Handwash White",
    label: "Handwash White",
    icon: Washing_icon_hand_White,
  },
];

export function getWashing() {
  return DEFAULT_WASHINGS;
}

/**
 * If washing instruction is not supported in the default_washing list
 * then, return null so we can ask the user to update the instructions
 */
export function getIconByValue(value) {
  const result = DEFAULT_WASHINGS.find((washing) => washing.value === value);
  return result ? result.icon : null;
}
